// extracted by mini-css-extract-plugin
export default {"HostServiceDetailPhotos__ImageSlider":"HostServiceDetailPhotos_HostServiceDetailPhotos__ImageSlider__wkRzV"};